/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

class PopUpShopTheLook {
    constructor() {
        this.shopTheLookButtons = document.querySelectorAll(".handle-popup-up-shop-the-look-cms");
        this.overlay = document.querySelector(".js-overlay");
        this.header = document.querySelector(".section-header");
        this.body = document.querySelector("body");
        this.focusableBeforeOpen = null;

        this.init();
    }

    init() {
        this.shopTheLookButtons.forEach((button) => {
            button.addEventListener("click", () => {
                this.openPopup(button);
            });
        });

        this.overlay?.addEventListener("click", () => {
            this.closePopup();
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.currentPopup) {
                this.closePopup();
            }
        });
    }

    openPopup = (button) => {
        this.focusableBeforeOpen = document.activeElement;

        this.overlay.classList.add("is-visible");
        this.header.classList.add("hide");
        this.body.classList.add("popup-open");

        const parent = button.closest('.section-shop-the-look');
        const popup = parent?.querySelector('.pop-up-container');
        const closeBtn = parent?.querySelector('.close-button-pop-up');

        if (popup) {
            popup.classList.add('show');
            this.currentPopup = popup;

            popup.setAttribute('aria-hidden', 'false');
            popup.setAttribute('aria-modal', 'true');

            this.trapFocus(popup);

            if (closeBtn) {
                closeBtn.focus();
            } else {
                const firstFocusable = this.getFocusableElements(popup)[0];
                firstFocusable?.focus();
            }
        }

        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                this.closePopup();
            });
        }

        this.header?.setAttribute('aria-hidden', 'true');
        document.querySelector('main')?.setAttribute('aria-hidden', 'true');
    };

    closePopup = () => {
        this.overlay.classList.remove("is-visible");
        this.header.classList.remove("hide");
        this.body.classList.remove("popup-open");

        if (this.currentPopup) {
            this.currentPopup.classList.remove('show');

            this.currentPopup.setAttribute('aria-hidden', 'true');
            this.currentPopup.removeAttribute('aria-modal');

            this.currentPopup = null;
        }

        this.header?.removeAttribute('aria-hidden');
        document.querySelector('main')?.removeAttribute('aria-hidden');

        if (this.focusableBeforeOpen) {
            this.focusableBeforeOpen.focus();
        }
    };

    trapFocus = (element) => {
        const focusableElements = this.getFocusableElements(element);
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        element.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        });
    };

    getFocusableElements = (element) => {
        return Array.from(
            element.querySelectorAll(
                'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
        );
    };
}

new PopUpShopTheLook();
